import { RemiTooltip, RemiTooltipContent, RemiTooltipTrigger } from "@remi/next-ui";
import { type PersonTagOption, PersonTagOptionDisplayNames } from "@remi/types/personTagOption";

interface TruncatedTagsProps {
  tags: { tag: PersonTagOption }[];
  maxLength?: number;
  className?: string;
  separator?: string;
}

export const TruncatedTags = ({
  tags,
  maxLength = 20,
  className = "text-text-primary text-xs font-medium",
  separator = " , ",
}: TruncatedTagsProps) => {
  if (tags.length === 0) {
    return null;
  }

  const tagNames = tags.map((tag) => PersonTagOptionDisplayNames[tag.tag]).filter(Boolean);
  const fullText = tagNames.join(separator);

  if (fullText.length <= maxLength) {
    return <span className={`${className} break-words`}>{fullText}</span>;
  }

  const ellipsis = "...";
  // Ensure there's enough space for the ellipsis
  let truncated = fullText.slice(0, maxLength - ellipsis.length);

  // Try to truncate at a word boundary
  const lastSeparatorIndex = truncated.lastIndexOf(separator);
  if (lastSeparatorIndex > 0) {
    truncated = truncated.slice(0, lastSeparatorIndex);
  }

  const truncatedText = truncated + ellipsis;

  return (
    <RemiTooltip>
      <RemiTooltipTrigger asChild>
        <span className={`${className} break-words`}>{truncatedText}</span>
      </RemiTooltipTrigger>
      <RemiTooltipContent align="start" className="max-w-xs">
        <div className="text-text-primary text-xs">{fullText}</div>
      </RemiTooltipContent>
    </RemiTooltip>
  );
};
